var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTagUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.34 2 3 3.33 3 4.97v10.91c0 1.64 1.34 2.98 3 2.98h.76c.79 0 1.56.31 2.12.87l1.71 1.69c.78.77 2.04.77 2.82 0l1.71-1.69c.56-.56 1.33-.87 2.12-.87H18c1.66 0 3-1.34 3-2.98V4.97C21 3.33 19.66 2 18 2H6zm7.95 5.5c0 1.06-.84 1.91-1.88 1.95h-.15a1.945 1.945 0 0 1-1.88-1.95c.01-1.07.88-1.95 1.96-1.95s1.95.88 1.95 1.95zm-4.7 7.19c-1.33-.88-1.33-2.34 0-3.23 1.52-1.01 4-1.01 5.5 0 1.33.89 1.33 2.34 0 3.23-1.51 1.01-3.99 1.01-5.5 0z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTagUser);
export default __webpack_public_path__ + "static/media/vuesax-bold-tag-user.3553f24e501c27352510ff3c7cf303b3.svg";
export { ForwardRef as ReactComponent };